// extracted by mini-css-extract-plugin
export var alternate = "_16-j";
export var black = "_16-6";
export var blue = "_16-f";
export var blueLight = "_16-e";
export var brand = "_16-8";
export var darkMode = "_16-b";
export var error = "_16-a";
export var gray = "_16-5";
export var grayBlue = "_16-d";
export var iconWrapper = "_16-3";
export var inactive = "_16-7";
export var indigo = "_16-g";
export var orange = "_16-i";
export var pink = "_16-h";
export var primary = "_16-0";
export var purple = "_16-9";
export var success = "_16-4";
export var warning = "_16-c";
export var white = "_16-1";
export var whiteSuccess = "_16-2";